import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServiceTiers } from './components/ServiceTiers';
import { Footer } from './components/Footer';
import { Pricing } from './pages/Pricing';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="bg-black text-white min-h-screen w-full" data-id="element-1">
        <Header data-id="element-2" />
        <main className="w-full" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<>
                  <HeroSection data-id="element-6" />
                  <ServiceTiers data-id="element-7" />
                </>} data-id="element-5" />
            <Route path="/pricing" element={<Pricing data-id="element-9" />} data-id="element-8" />
          </Routes>
        </main>
        <Footer data-id="element-10" />
      </div>
    </BrowserRouter>;
}